<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Performance Results</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <span class="configurationInput">
          <label class="configurationInputLabel">Airflow:</label>
          <input readonly="readonly" [value]="airflow" class="configurationRatingValueOutput">
          <label class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits() }}</label>
        </span>
        <span class="configurationInput">
          <label class="configurationInputLabel">Power:</label>
          <input readonly="readonly" [value]="outputPower" class="configurationRatingValueOutput">
          <label class="configurationRatingUnitLabel">Watts</label>
        </span>
        <span class="configurationInput">
          <label class="configurationInputLabel">FLA:</label>
          <input readonly="readonly" [value]="fullLoadAmps" class="configurationRatingValueOutput">
        </span>
      </div>
      <app-heating-only-performance-results [ratingResponse]="ratingResponse()" [isMetric]="isMetric">
      </app-heating-only-performance-results>
    </div>
  }
</div>
